/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Kódy bezbariérové přístupnosti objektu (hodnoty atributu typu ACCESSIBILITY; v surové hodnotě jsou oddělené středníkem). Jediný zdroj pravdy sdílený serverem i klientem – klient k jednotlivým kódům doplňuje ikony a barevné rozlišení, server popisky. Kanonické popisky viz x-enum-descriptions.
 * @export
 * @enum {string}
 */

export const EnumAccessibility = {
    /**
    * Bezbariérový vstup hlavním vchodem
    */
    VSTUP_HLAVNI: 'vstup_hlavni',
    /**
    * Bezbariérový vstup bočním vchodem
    */
    VSTUP_BOCNI: 'vstup_bocni',
    /**
    * Ližiny nebo rampa
    */
    LISINY_RAMPA: 'lisiny_rampa',
    /**
    * Objekt přístupný
    */
    OBJEKT_PRISTUPNY: 'objekt_pristupny',
    /**
    * Objekt částečně přístupný
    */
    OBJEKT_CASTECNE: 'objekt_castecne',
    /**
    * Objekt obtížně přístupný nebo nepřístupný
    */
    OBJEKT_NEPRISTUPNY: 'objekt_nepristupny',
    /**
    * Obtížný povrch
    */
    OBTIZNY_POVRCH: 'obtizny_povrch',
    /**
    * Obtížný sklon
    */
    OBTIZNY_SKLON: 'obtizny_sklon',
    /**
    * Plošina / výtah pro osoby s omez. schop. pohybu
    */
    PLOSINA_VYTAH: 'plosina_vytah',
    /**
    * Schody
    */
    SCHODY: 'schody',
    /**
    * Točité schodiště
    */
    TOCITE_SCHODISTE: 'tocite_schodiste',
    /**
    * Výtah
    */
    VYTAH: 'vytah',
    /**
    * WC běžné
    */
    WC_BEZNE: 'wc_bezne',
    /**
    * WC I.
    */
    WC1: 'wc1',
    /**
    * WC II.
    */
    WC2: 'wc2',
    /**
    * Úzké dveře nebo průjezdy
    */
    UZKE_DVERE: 'uzke_dvere'
} as const;

export type EnumAccessibility = typeof EnumAccessibility[keyof typeof EnumAccessibility];



